module.exports = __webpack_public_path__ + "img/sample.7f4c9c34.png";